import { UseSearchPlayers_PlayerFragment } from "@/gen/graphql";

export function toPlayerFragment(
    player: { id: string; name: string } | Partial<UseSearchPlayers_PlayerFragment> | null
): UseSearchPlayers_PlayerFragment | null {
    if (!player) return null;
    return {
        __typename: "Player",
        id: typeof player.id === "string" ? player.id : "",
        name: typeof player.name === "string" ? player.name : "",
        fideId: "fideId" in player && typeof player.fideId === "number" ? player.fideId : null,
        nickname:
            "nickname" in player && typeof player.nickname === "string" ? player.nickname : "",
        imageId:
            "imageId" in player && (typeof player.imageId === "string" || player.imageId === null)
                ? player.imageId
                : null,
    };
}
